import { useEffect, useReducer } from "react";
import { useRouter } from "next/router";
import styles from "@/styles/PageTransitionLoading.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var initialState = {
  progress: 0,
  show: true
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "increment":
      var newProgres = state.progress + 10;
      return {
        progress: newProgres,
        show: true
      };

    case "update":
      return {
        progress: action.progress,
        show: true
      };

    case "complete":
      return {
        progress: 0,
        show: false
      };
  }
};

export default function PageTransitionLoading() {
  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var router = useRouter();
  useEffect(function () {
    var handleHistoryChangeStart = function handleHistoryChangeStart() {
      return dispatch({
        type: "increment"
      });
    };

    var handleHistoryChangeComplete = function handleHistoryChangeComplete() {
      return dispatch({
        type: "update",
        progress: 100
      });
    };

    router.events.on("routeChangeStart", handleHistoryChangeStart);
    router.events.on("routeChangeComplete", handleHistoryChangeComplete);
    return function () {
      router.events.off("routeChangeStart", handleHistoryChangeStart);
      router.events.off("routeChangeComplete", handleHistoryChangeComplete);
    };
  }, []);
  useEffect(function () {
    var mounted = true;
    var timeoutId;

    if (mounted) {
      if (state.progress > 0 && state.progress < 90) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () {
          return dispatch({
            type: "increment"
          });
        }, 300);
      } else if (state.progress == 100) {
        timeoutId = setTimeout(function () {
          dispatch({
            type: "complete"
          });
        }, 700);
      }
    }

    return function () {
      mounted = false;
      clearTimeout(timeoutId);
    };
  }, [state.progress]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: state.show && /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.bar,
        style: {
          width: "".concat(state.progress, "%")
        }
      })
    })
  });
}